'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Language = function Language() {
  'ngInject';

  return {
    getAvailableLanguageKeys: getAvailableLanguageKeys,
    getDefaultLanguage: getDefaultLanguage
  };

  function getAvailableLanguageKeys() {
    return ['IT', 'EN', 'DE', 'FR', 'NL'];
  }

  function getDefaultLanguage() {
    return getAvailableLanguageKeys()[0];
  }
};

exports.default = Language;


// WEBPACK FOOTER //
// ./client/app/common/factories/languageFactory/language.factory.js